import React from "react";
import { motion } from "framer-motion";

const items = [
  { emoji: "📍", label: "+20 attività locali gestite" },
  { emoji: "📱", label: "Contenuti verticali nativi" },
  { emoji: "🎬", label: "Video editing avanzato" },
  { emoji: "✦", label: "Metodo RIM™ proprietario" },
];

export default function SocialProofStrip() {
  return (
    <section
      data-testid="social-proof-strip"
      className="bg-rim-night text-rim-text py-6 md:py-8 border-y border-white/5"
    >
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-40px" }}
        transition={{ duration: 0.6 }}
        className="-mx-4 px-4 sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8 flex gap-2.5 overflow-x-auto scrollbar-hide"
        style={{ WebkitOverflowScrolling: "touch" }}
      >
        {items.map((it) => (
          <span
            key={it.label}
            className="shrink-0 inline-flex items-center gap-2 bg-rim-surface border border-rim/35 rounded-full px-4 py-2.5 text-[13px] font-medium text-rim-text whitespace-nowrap"
          >
            <span className="text-base leading-none">{it.emoji}</span>
            {it.label}
          </span>
        ))}
        <span className="shrink-0 w-2" aria-hidden />
      </motion.div>
    </section>
  );
}
